import { render } from "./VideoRecorderError.vue?vue&type=template&id=3be9a06b"
import script from "./VideoRecorderError.vue?vue&type=script&lang=ts"
export * from "./VideoRecorderError.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./VideoRecorderError.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script